export const  getRandomColor=()=> {
    var colorArray=[
        '#f44336',
        '#e91e63',
        '#9c27b0',
        '#3f51b5',
        '#2196f3',
        '#2196f3',
        '#00bcd4',
        '#009688',
        '#4caf50',
        '#8bc34a',
        '#ff9800',
        '#6574cf',
        '#40a9ff'


        
    ]
    var color=colorArray[Math.floor(Math.random()*colorArray.length)];
    //console.log(color);
    return color;
    
  }
    // var letters = '0123456789ABCDEF';
    // var color = '#';
    // for (var i = 0; i < 6; i++) {
    //   color += letters[Math.floor(Math.random() * 16)];
    // }
    // var color = '#';
    // for (var i = 0; i < 6; i++) {
    //     color += Math.floor(Math.random() * 10);
    // }
    // return color;
    